// src/lib/supabaseClient.js
// Supabase client — only active when REACT_APP_USE_AWS is not 'true'
import { createClient } from '@supabase/supabase-js';

const supabaseUrl    = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
const useAWS = (process.env.REACT_APP_USE_AWS || '').trim() === 'true';

// In AWS mode the Supabase vars are intentionally empty — don't crash
if (!supabaseUrl || !supabaseAnonKey) {
  if (!useAWS) {
    throw new Error('Missing Supabase environment variables. Please check your .env file.');
  }
}

export const supabase = (supabaseUrl && supabaseAnonKey)
  ? createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true,
      },
    })
  : null;

export const getCurrentUser = async () => {
  if (!supabase) return null;
  const { data: { user }, error } = await supabase.auth.getUser();
  if (error) throw error;
  return user;
};

export const getUserPractice = async (userId) => {
  if (!supabase) return null;

  const timeoutPromise = new Promise((_, reject) =>
    setTimeout(() => reject(new Error('getUserPractice timeout after 10 seconds')), 10000)
  );

  const fetchPromise = (async () => {
    const { data: user, error: userError } = await supabase
      .from('users')
      .select('id, email, full_name, approved, active, practice_id, role')
      .eq('id', userId)
      .single();

    if (userError) throw userError;
    if (!user) throw new Error('User not found');

    let practice = null;
    if (user.practice_id) {
      const { data: practiceData } = await supabase
        .from('practices')
        .select('*')
        .eq('id', user.practice_id)
        .single();
      if (practiceData) practice = practiceData;
    }

    return {
      ...user,
      practice: practice || { name: user.approved ? 'No Practice' : 'Pending Approval', id: user.practice_id },
    };
  })();

  return Promise.race([fetchPromise, timeoutPromise]);
};

export const signOut = async () => {
  if (!supabase) return;
  const { error } = await supabase.auth.signOut();
  if (error) throw error;
};
